import React from 'react';
import { Box } from '@mui/material';
import { getBackgroundSx, tokens } from '../../theme/tokens';

type PortalPageTemplateProps = {
  darkMode: boolean;
  children?: React.ReactNode;
};

const PortalPageTemplate: React.FC<PortalPageTemplateProps> = ({ darkMode, children }) => {
  return (
    <Box
      sx={{
        ...getBackgroundSx(darkMode),
        position: 'relative',
        isolation: 'isolate',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: darkMode
            ? 'radial-gradient(circle at 20% -10%, rgba(255,255,255,0.06), transparent 35%), radial-gradient(circle at 90% 0%, rgba(255,255,255,0.04), transparent 28%)'
            : 'radial-gradient(circle at 20% -10%, rgba(13,53,89,0.1), transparent 35%), radial-gradient(circle at 90% 0%, rgba(178,20,15,0.08), transparent 28%)',
          pointerEvents: 'none',
          zIndex: 0
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: darkMode
            ? 'linear-gradient(to bottom, rgba(0,0,0,0.15), transparent 20%, transparent 80%, rgba(0,0,0,0.2))'
            : 'linear-gradient(to bottom, rgba(255,255,255,0.35), transparent 25%, transparent 80%, rgba(13,53,89,0.05))',
          pointerEvents: 'none',
          zIndex: 0
        },
        '& > *': {
          position: 'relative',
          zIndex: 1
        },
        color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text
      }}
    >
      {children}
    </Box>
  );
};

export default PortalPageTemplate;
